module.exports = __webpack_public_path__ + "static/media/title-event.1460c8d7.png";